<template>
    <div class="pms-download">
        <div class="pms-download-box">
            <div class="pms-log-box">
                <div class="pms-logo">
                    <el-image :src="pmsLogo" fit="fill"></el-image>
                </div>
                <div class="download-text">樓盤 輕鬆管理</div>
            </div>
        </div>
        <div class="pms-download-button">
            <el-image :src="appStoreLogo" fit="fill" @click="downloadFromAppStore"></el-image>
            <el-image :src="googlePlayLogo" fit="fill" @click="downloadFromGooglePlay"></el-image>
        </div>
        <div class="pms-qrcode-box">
            <div class="pms-qrcode">
                <Qrcode :url="qrCodeUrl" :iconurl="qrCodeLogo" :wid="140" :hei="140" :imgwid="53" :imghei="53"></Qrcode>
            </div>
            <div class="pms-qrcode-text">
                掃瞄QR Code下載
            </div>
        </div>
        <div class="pms-download-background">
            <el-image class="pms-download-img" :src="appUi" fit="fill"></el-image>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppDownload',
    data() {
        return {
            pmsLogo: require('../../assets/pms730-logo.png'),
            appStoreLogo: require('../../assets/app-store-badge-us-black.png'),
            googlePlayLogo: require('../../assets/google-play-badge-us.png'),
            appUi: require('../../assets/app-ui.png'),
            qrCodeLogo: require('../../assets/QRCodeLogo.png'),
            qrCodeUrl: this.pub.config.qrDownApp
            //  this.pub.config.qrDownApp
            // qrCodeUrl: window.location.href.concat('/qrcodedownload')
        };
    },
    methods: {
        downloadFromAppStore() {
            // window.location.href = 'https://itunes.apple.com/cn/app/id1492668798'
            window.location.href = 'https://apps.apple.com/hk/app/id1492668798';
        },
        downloadFromGooglePlay() {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.house730.pms';
        }
    }
};
</script>

<style scoped lang="less">
.pms-download {
    padding-left: 105px;
    padding-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    .pms-download-box {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        .pms-logo {
            margin-bottom: 10px;
        }
        .download-text {
            font-size: 28px;
            font-weight: 500;
            color: rgba(4, 6, 55, 1);
            line-height: 40px;
            margin-bottom: 28px;
        }
    }

    .pms-download-button {
        .el-image:nth-child(1) {
            margin-right: 14px;
        }
        .el-image {
            cursor: pointer;
        }
        margin-bottom: 52px;
    }

    .pms-qrcode-box {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        .pms-qrcode {
            padding: 8px 8px 5px 8px;
            background: rgba(255, 255, 255, 1);
            margin-bottom: 10px;
        }
        .pms-qrcode-text {
            font-size: 15px;
            font-weight: 500;
            color: rgba(0, 71, 156, 1);
            line-height: 21px;
        }
    }
}

@media screen and (min-width: 1300px) {
    .pms-download-background {
        position: fixed;
        right: 0px;
        bottom: -5px;
    }
    .pms-download-img {
        transform: scale(1);
    }
}
@media screen and (max-width: 1300px) and (min-width: 1100px) {
    .pms-download-background {
        position: fixed;
        right: -100px;
        bottom: -5px;
    }
    .pms-download-img {
        transform: scaleX(0.9);
    }
}

@media screen and (max-width: 1100px) {
    .pms-download-background {
        position: fixed;
        right: -150px;
        bottom: -90px;
    }
    .pms-download-img {
        transform: scale(0.85);
    }
}
</style>
